import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function DataSelector({ label, roiIds, setCurrentRoi, defaultRoi }) {
  const [roi, setRoi] = React.useState(defaultRoi);

  const handleChange = (event) => {
    setRoi(event.target.value);
    setCurrentRoi(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={roi}
          label="Age"
          size="small" margin="dense"
          onChange={handleChange}
        >
          {roiIds ? roiIds.map((roi) => {
            return < MenuItem key={roi} value={roi}>
              {(roi == 'WholeLane') ? roi : `Region #${roi.slice(0, 5)}`}
            </MenuItem>
          }) : ""}
        </Select>
      </FormControl>
    </Box >
  );
}
